
<style>
.inbound-steps .vview-icons-ios-checkmark-empty::before {
	content: "\F171";
}
</style>

<template>
	<vSteps v-if="getCurIndex>-1" :current="getCurIndex" class="bg-fff padding-20 inbound-steps">
		<vStep v-for="(val,key) of progressStatus" :title="val.name" :key="key"></vStep>
	</vSteps>
</template>

<script>
export default {
	props: ['status', 'needBox'],
	computed: {
		getCurIndex() {
			return this.progressStatus.findIndex((item) => {
				return item.value == this.status
			})
		},
		progressStatus() {
			// DRAFT(0, "草稿"),
			// UNCHECK(5, "待审核"),
			// CHECK_REFUSED(6,"审核拒回"),
			// UN_BOXED(8, "待装箱"),
			// UNSHIPPED(10, "待发货"),
			// UNRECEIVED(15, "待接收"),
			// UNSTOCKIN(20, "待入库"),
			// INBOUNDING(25, "入库中"),
			// COMPLETED(70, "已完成"),
			// CLOSED(90, "已关闭"),
			// CANCELED(100,"已取消");
			const isRefused = this.status == 6;
			const isCancel = this.status == 100;
			const arr = [{
				name: this.$t('fbb.inbound.draft',{defaultValue:'草稿'}),
				value: '0',
				show: !isRefused
			}, {
				name: this.$t('fbb.inbound.back_audit',{defaultValue:'审核拒回'}),
				value: '6',
				show: isRefused
			}, {
				name: this.$t('fbb.inbound.check_pending',{defaultValue:'待审核'}),
				value: '5',
				show: true,
			}, {
				name: this.$t('fbb.inbound.for_packing',{defaultValue:'待装箱'}),
				value: '8',
				show: this.needBox,
			}, {
				name: this.$t('fbb.inbound.send_goods',{defaultValue:'待发货'}),
				value: '10',
				show: !this.needBox
			}, {
				name: this.$t('fbb.inbound.stock_pending',{defaultValue:'待入库'}),
				value: '20',
				show: true,
			}, {
				name: this.$t('fbb.inbound.inthe_library',{defaultValue:'入库中'}),
				value: '25',
				show: true,
			}, {
				name: this.$t('global.common.finished',{defaultValue:'已完成'}),
				value: '70',
				show: true,
			}]
			return isCancel ? [{
				name: this.$t('global.common.canceled',{defaultValue:'已取消'}),
				value: '100',
			}] : arr.filter(item => item.show)
		}
	}
}
</script>